module.exports = __webpack_public_path__ + "media/src/images/cracker-b0b77647ff1999582e90ccd0f46171de.png";